<template>
  <v-dialog
    v-model="dialog_active"
    width="800">
    <HelpModal
      @close="dialog_active = false"
      :mdxName="mdxName" />
  </v-dialog>

  <div
    @click="dialog_active = true"
    title="Show Information for this Section"
    class="help-icon ibtn-container mr-3 pa-1">
    <v-icon>mdi-information</v-icon>
  </div>
</template>

<script setup>
import { watch, ref } from 'vue';
import HelpModal from './HelpModal.vue';

const dialog_active = ref(false);
const props = defineProps(['mdxName']);
</script>

<style scoped>
.help-icon {
  border-radius: 24px;
  width: 24px;
  height: 24px;
  margin-right: 12px;
}
</style>
